import { render } from "./QuestionObjectPhoneticVowel.vue?vue&type=template&id=68010926&scoped=true"
import script from "./QuestionObjectPhoneticVowel.vue?vue&type=script&lang=js"
export * from "./QuestionObjectPhoneticVowel.vue?vue&type=script&lang=js"

import "@/css/components/question-object-phonetic-vowel.css?vue&type=style&index=0&id=68010926&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68010926"]])

export default __exports__